module.exports = __webpack_public_path__ + "img/3h.d0c3abd2.png";